module.exports = __webpack_public_path__ + "img/lang-10.f77475b9.jpg";